import controllerLoadedObservableFactory from '@newswebsiteapp/shared/observables/controllerLoadedObservableFactory'

import { setPublicationShowPageFontSize } from './lib/fontSizeStorage'

controllerLoadedObservableFactory('publication_show_page').subscribe(() => {
  $('.font-plus').click(() => {
    const px = $('.publication-content__content-block')
      .css('font-size')
      .split('px')[0]

    const newSize = Number(px) + 1

    if (newSize <= 40) {
      $('.publication-content__content-block').css('font-size', `${newSize}px`)

      setPublicationShowPageFontSize(newSize)
    }
  })

  $('.font-minus').click(() => {
    const px = $('.publication-content__content-block')
      .css('font-size')
      .split('px')[0]

    const newSize = Number(px) - 1

    if (newSize >= 8) {
      $('.publication-content__content-block').css('font-size', `${newSize}px`)

      setPublicationShowPageFontSize(newSize)
    }
  })
})
